export default __webpack_public_path__ + "static/media/logo-stripe.6127e3bb.png";